<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

               <v-card>

                   <v-breadcrumbs divider="/">
                       <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                       <v-breadcrumbs-item :disabled="true">Korisnici</v-breadcrumbs-item>
                   </v-breadcrumbs>

               </v-card>

                <v-card class="m-20" v-if="users">

                    <v-data-table
                            :headers="headers"
                            :items="users"
                            :pagination.sync="pagination"
                            :total-items="total_users"
                            :loading="loading"
                            :rows-per-page-items=[50,25,10]
                            rows-per-page-text="redova po strani"
                            class="elevation-1"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.id }}</td>
                            <td class="text-xs-left">{{ props.item.name }}</td>
                            <td class="text-xs-left">{{ props.item.email }}</td>
                            <td class="text-xs-left">[<span v-for="role in props.item.role">{{ role.name }}</span>,]</td>
                            <td class="text-xs-left">{{ props.item.block }}</td>
                            <td class="text-xs-left">{{ props.item.created_at }}</td>
                            <td class="text-xs-right">

                                <v-tooltip bottom>
                                    <!--<v-btn slot="activator" small color="secondary" class="black&#45;&#45;text" :to="'/users/' + props.item.id + '/edit'" v-if="checkGuard('user-edit')">-->
                                    <v-btn slot="activator" small color="secondary" class="black--text" :to="'/users/' + props.item.id + '/edit'">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <span>Izmeni</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <!--<v-btn slot="activator" small color="error" @click="destroy(props.item)" v-if="checkGuard('user-delete')">-->
                                    <v-btn slot="activator" small color="error" @click="destroy(props.item)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                    <span>Obriši</span>
                                </v-tooltip>

                            </td>
                        </template>

                    </v-data-table>

                </v-card>

            </v-flex>

            <!--<v-fab-transition v-if="checkGuard('user-create')">-->
            <v-fab-transition>

                <v-btn :color="'primary'" dark fab fixed bottom right to="/users/create">
                    <v-icon>playlist_add</v-icon>
                    <v-icon>close</v-icon>
                </v-btn>

            </v-fab-transition>


        </v-layout>
    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data() {
            return {
                total_users: 0,
                loading: true,
                pagination: {
                    descending: true,
                },
                users: false,
                headers: [
                    {text: 'ID', align: 'left', sortable: true, value: 'id'},
                    {text: 'IME', align: 'left', sortable: true, value: 'name'},
                    {text: 'EMAIL', sortable: true, value: 'email'},
                    {text: 'ULOGE', sortable: false, value: 'block'},
                    {text: 'BLOKIRAN', sortable: true, value: 'block'},
                    {text: 'KREIRANO',sortable: false,  value: 'created_at'},
                    {text: 'AKCIJA', align: 'right', value: 'action'},
                ],
            }
        },
        mounted() {
            this.getUsers();
        },
        computed: {
            user(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            getUsers() {
                this.loading = true;
                const { sortBy, descending, page, rowsPerPage } = this.pagination;

                axios.get(`users?${sortBy}=1&page=${page}&DESC=${descending? 1 : 0}&paginate=${rowsPerPage}`)
                    .then(res => {
                        this.users = res.data.users.data;
                        this.total_users = res.data.users.total;
                        this.loading = false;
                    }).catch(e => {
                        console.log(e.response);
                        this.error = e.response.data.errors;
                    });
            },
            destroy(row){
                swal({
                    title: 'Da li ste sigurni?',
                    text: 'Nećete moći da povratite radnju',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: this.$vuetify.theme.primary,
                    cancelButtonColor: this.$vuetify.theme.secondary,
                    confirmButtonText: 'Da, obriši.',
                    cancelButtonText: 'Odustani',
                }).then((result) => {
                    if (result.value) {
                        axios.delete('users/' + row.id)
                            .then(res => {
                                this.getUsers();
                                swal(
                                    'Obrisano',
                                    'Uspešno ste obrisali',
                                    'success',
                                );
                            })
                            .catch(e => {
                                console.log(e);
                            });
                    }
                });
            },
            checkGuard(name){
                let res = false;
                let permissionList = this.$store.getters['ability/getPermissionList'];
                permissionList.forEach(permission => {
                    if(name === permission.name){
                        res = true;
                    }
                });
                return res;
            },
        },
        watch: {
            pagination: {
                handler () {
                    this.getUsers();
                },
                deep: true
            }
        },
    }
</script>

<style scoped>
    .swal2-styled.swal2-confirm{
        border-radius: 0 !important;
    }
</style>
